import React from 'react';

const DeltaIconNeutral = ({ color }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="rotate(45 12 12)">
      <circle cx="12" cy="12" r="12" fill={color} />
      <path d="M6.64453 16.6465L16.5 7.5" stroke="white" />
      <line x1="8" y1="7.5" x2="16" y2="7.5" stroke="white" />
      <line x1="16.5" y1="8" x2="16.5" y2="16" stroke="white" />
    </g>
  </svg>
);

export default DeltaIconNeutral;
